import React from 'react';
import { ContactStyled } from './Contact.styled';
import Container from '../../components/Container/Container';
import { PageTitle, SectionTitle } from '../../components/PageTitle/PageTitle.styled';
import Section from '../../components/Section/Section';
import { CardDescription } from '../../components/Card/Card.styled';
import FormWithContacts from '../../components/Form/FormWithContacts';
import Card from '../../components/Card/Card';
import CustomersBlock from '../../components/CustomersBlock/CustomersBlock';
// @ts-ignore
import SEO from '@americanexpress/react-seo';

function Contact(): JSX.Element {
  return (
    <ContactStyled>
      <SEO
        title="RGRauto | Contacts"
      />
      <Section style={{ paddingTop: '0' }}>
        <Container>
          <PageTitle>Contact us</PageTitle>
          <p>Have a question? Would you like to speak with us?</p>
          <Card>
            <CardDescription>
              Please fill out the form below and we will <br />
              contact you as soon as possible
            </CardDescription>
            <FormWithContacts />
          </Card>
        </Container>
      </Section>

      <Section style={{ paddingTop: '0' }}>
        <Container>
          <SectionTitle>We proudly serve private small-to-medium fleets as well as large corporate fleets</SectionTitle>
          <CustomersBlock />
        </Container>
      </Section>
    </ContactStyled>
  );
}

export default Contact;
